import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './ProfileBlock.module.scss';
import clsx from 'clsx';
import Block from '../Block/Block';
import Row from '../Row/Row';
import Link from '../Link/Link';
import { userGeneratePassword } from '../../redux/actions/user/userGeneratePassword';
import Swal from 'sweetalert2';
const ProfileBlock = ({ children }) => {
  const dispatch = useDispatch();
  const {
    userMe: { data: userMeData, loading: userMeLoading, error: userMeError },
  } = useSelector((state) => state.user);

  const onGeneratePassword = () => {
    Swal.fire({
      title: `Вы уверены что хотите сгенерировать новый пароль`,
      text: 'Новый пароль будет отправлен на вашу почту',
      showCancelButton: true,
      showConfirmButton: true,
      background: '#fff',
      cancelButtonColor: '#fc564a',
      cancelButtonText: 'Отмена',
      confirmButtonColor: '#65c15c',
      confirmButtonText: 'Сгенерировать',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(userGeneratePassword());
      }
    });
  };
  return (
    <>
      <Block title="Данные профиля">
        <div className={clsx(styles.content)}>
          <Row label="Логин" value={userMeData?.email} />
          <Link onClick={onGeneratePassword}>Сгенирировать новый пароль для входа</Link>
          {children}
        </div>
      </Block>
    </>
  );
};

export default ProfileBlock;
